import {Routes, Route} from 'react-router-dom';
import LogisticRegressionIntro from "./LogisticRegressionIntro";
import LogisticRegressionCostFunction from "./LogisticRegressionCostFunction";
import LogisticRegressionGradientDescent from "./LogisticRegressionGradientDescent";
import LogisticRegressionAbout from "./LogisticRegressionAbout";

const LogisticRegressionRoutes = () => {
    return (
        <>
            <Routes>
                <Route path="/" element={<LogisticRegressionIntro/>}/>
                <Route path="/about" element={<LogisticRegressionAbout/>}/>
                <Route path="/gradient-descent" element={<LogisticRegressionGradientDescent/>}/>
                <Route path="/cost-function" element={<LogisticRegressionCostFunction/>}/>
            </Routes>
        </>
    )
}

export default LogisticRegressionRoutes;